import { startsWith } from 'lodash';
import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import AccountsActionCreator from '../actions/AccountsActionCreator';
import FavouritesActionCreator from '../actions/AccountsActionCreator/FavouritesActionCreator';
import InternetBankingActions from '../actions/InternetBankingActions';
import MoveMoneyActionCreator from '../actions/MoveMoneyActionCreator';

const _getAccountListEndpoint = '/ibapi/v2/banks/{bank-id}/accounts/default';
const _getAccountDetailsEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}';
const _getPotsDataEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}/pots';
const _getProjectionEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}/projection';
const _getAccountBalanceEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/balances/file';
const _getAccountListByCapabilityEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default?page=1&size=1&paymentType={payment-type}';

class AccountsApiUtils {
  /**
   * API call for getAccoountList.
   * Retrieves the list of accounts for a customer.
   */
  static getAccountsList() {
    let url = envConfig.apiBaseUrlPAAS + _getAccountListEndpoint;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.timelineService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body, status) => {
        AccountsActionCreator.handleAccountsListSuccess(body);
      },
      (error, status) => {
        if (
          status === 401 &&
          startsWith(
            error.headers[config.authenticateHeaderName],
            'Bearer realm error=tsandcs'
          )
        ) {
          setTimeout(() => {
            this.getAccountsList();
          }, 5000);
        } else if (status === 403) {
          InternetBankingActions.navigateToWebTask('WEB-NONBCUSTOMERERROR');
        } else {
          AccountsActionCreator.handleAccountsListError(error, status);
        }
      }
    );
  }

  /**
   * API call for getAccoountDetails.
   * Retrieves the details of account for a customer.
   */
  static getAccountDetails(account_number) {
    let url = envConfig.apiBaseUrlPAAS + _getAccountDetailsEndpoint;
    url = url.replace('{account-id}', account_number);
    if (envConfig.stubConfig) {
      const key = `AccountDetailsConnection-${account_number}`;
      url = envConfig.stubConfig.timelineStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.timelineService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        AccountsActionCreator.handleAccountsDetailsSuccess(body);
      },
      (error, status) => {
        AccountsActionCreator.handleAccountsDetailsError(
          account_number,
          error,
          status
        );
      }
    );
  }

  /**
   * API call for getAccountsByCapability.
   * Retrieves the accounts based of a capability
   */
  static getAccountsByCapability(accountCapability) {
    let url = (
      envConfig.apiBaseUrlPAAS + _getAccountListByCapabilityEndpoint
    ).replace('{payment-type}', encodeURIComponent(accountCapability));
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.timelineService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        FavouritesActionCreator.handleQuickLinkPermissionSuccess(body);
      },
      (error) => {
        InternetBankingActions.navigateToWebTask('WEB-ERROR');
      }
    );
  }
  /**
   * API Call to get Projection Danger Period.
   */
  static getProjectionDetails(accid) {
    let url = envConfig.apiBaseUrlPAAS + _getProjectionEndpoint;
    url = url.replace('{account-id}', accid);
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.projectionService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        AccountsActionCreator.handleDangerPeriodDataSuccess(body, accid);
      },
      (error) => {
        // AccountsActionCreator.handleDangerPeriodDataError(error);
      }
    );
  }
  /**
   * API Call to get Pots Rejig case.
   */
  static getPotsData(accid) {
    let url = envConfig.apiBaseUrlPAAS + _getPotsDataEndpoint;
    url = url.replace('{account-id}', accid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        AccountsActionCreator.handlePotDataSuccess(body, accid);
        // This should be refactored with BOW-2520
        const resp = {
          id: accid,
          pots: body,
        };
        MoveMoneyActionCreator.handlePotsDetailsSuccess(resp);
      },
      (error) => {
        // AccountsActionCreator.handlePotDataError(error);
      }
    );
  }
  /**
   * API Call to get balance export.
   */
  static requestBalance(balance_data, success, error) {
    const url = envConfig.apiBaseUrlPAAS + _getAccountBalanceEndpoint;
    ApiUtils.makeRequest(
      { url, method: 'POST', apiVersion: '0.8.0', requestData: balance_data },
      success,
      error
    );
  }
}

export default AccountsApiUtils;
